import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7511e7ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["src"]

import { watch, computed, onMounted } from "vue";

    const ratio = '16:9';
    const allowFullScreen = true;
    const animationSpeed = 300;
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalVideo',
  props: {
      videoId: { type: String, required: true },
      isOpen: { type: Boolean, required: true },
    },
  emits: ["close"],
  setup(__props, { emit: emits }) {

const props = __props;

    

    

    let youtube = {
      autoplay: 1,
      cc_load_policy: 1,
      color: null,
      controls: 1,
      disablekb: 0,
      enablejsapi: 0,
      end: null,
      fs: 1,
      h1: null,
      iv_load_policy: 1,
      list: null,
      listType: null,
      loop: 0,
      modestbranding: null,
      origin: null,
      playlist: null,
      playsinline: null,
      rel: 0,
      showinfo: 1,
      start: 0,
      wmode: 'transparent',
      theme: 'dark'
    };
    const classNames = {
      modalVideoEffect: 'modal-video-effect',
      modalVideo: 'modal-video',
      modalVideoClose: 'modal-video-close',
      modalVideoBody: 'modal-video-body',
      modalVideoInner: 'modal-video-inner',
      modalVideoIframeWrap: 'modal-video-movie-wrap',
      modalVideoCloseBtn: 'modal-video-close-btn'
    };
    const aria = {
      openMessage: 'Modal video opened',
      dismissBtnMessage: 'Close the modal video'
    };

    const getQueryString = (obj) => {
      let url = ''
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] !== null) {
            url += key + '=' + obj[key] + '&'
          }
        }
      }
      return url.substr(0, url.length - 1)
    };

    const getYoutubeUrl = (youtube, videoId) => {
      const query = getQueryString(youtube)
      return '//www.youtube.com/embed/' + videoId + '?' + query
    };


    const getPadding = (r) => {
      const arr = r.split(':')
      const width = Number(arr[0])
      const height = Number(arr[1])
      const padding = height * 100 / width
      return padding + '%'
    };

    const fullVideoUrl = computed(() => {
      return getYoutubeUrl(youtube, props.videoId)
    });

    const paddingBottom = computed(() => {
      return getPadding(ratio)
    });

    // watch(() => props.isOpen,
    //   (newVal) => {
    //   }
    // );

  
return (_ctx: any,_cache: any) => {
  return (__props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(classNames.modalVideo),
          tabIndex: "-1",
          role: "dialog",
          "aria-label": aria.openMessage,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close'))),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emits('close')), ["esc"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(classNames.modalVideoBody)
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(classNames.modalVideoCloseBtn),
              "aria-label": aria.dismissBtnMessage,
              ref: "closeBtn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
            }, null, 10, _hoisted_3),
            _createElementVNode("div", {
              class: _normalizeClass(classNames.modalVideoInner)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(classNames.modalVideoIframeWrap),
                style: _normalizeStyle({'padding-bottom': paddingBottom.value})
              }, [
                _createElementVNode("iframe", {
                  width: "460",
                  height: "230",
                  src: fullVideoUrl.value,
                  frameBorder: "0",
                  allowFullScreen: allowFullScreen,
                  tabIndex: "-1"
                }, null, 8, _hoisted_4)
              ], 6)
            ], 2)
          ], 2)
        ], 42, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})